function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_52",
  "data-name": "Group 52",
  transform: "translate(8659.44 -7981.381)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_50",
  "data-name": "Group 50"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_141",
  "data-name": "Path 141",
  d: "M-8494.176,8039.99c-.955-26.152-26.752-43.9-52.071-36.892-23.886-35.024-79.779-20.548-81.688,21.948-44.906,12.142-36.308,78.454,10.986,78.454h111.786C-8467.424,8103.5-8459.3,8051.2-8494.176,8039.99Z",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 4,
  fillRule: "evenodd"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_51",
  "data-name": "Group 51"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_142",
  "data-name": "Path 142",
  d: "M-8538.372,8059.205a1.5,1.5,0,0,0-.133-.51l-8.462-18.365a5.341,5.341,0,0,0-4.863-3.061h-6.463a1.3,1.3,0,0,0-1.332,1.275,1.3,1.3,0,0,0,1.332,1.276h6.463a2.67,2.67,0,0,1,2.4,1.53l7.729,16.707h-14.458a1.319,1.319,0,0,0-1.266,1.021,7.349,7.349,0,0,1-7.263,5.8,7.349,7.349,0,0,1-7.262-5.8,1.317,1.317,0,0,0-1.266-1.021h-14.457l7.728-16.707a2.671,2.671,0,0,1,2.4-1.53h6.462a1.305,1.305,0,0,0,1.333-1.276,1.3,1.3,0,0,0-1.333-1.275h-6.462a5.343,5.343,0,0,0-4.864,3.061l-8.461,18.365a1.459,1.459,0,0,0-.133.51v15.241a5.219,5.219,0,0,0,5.33,5.1h41.973a5.219,5.219,0,0,0,5.33-5.1Zm-2.665,15.241a2.539,2.539,0,0,1-2.53,2.551h-42.107a2.551,2.551,0,0,1-2.665-2.422c0-.043,0-.086,0-.129v-13.838h14.057a9.982,9.982,0,0,0,9.594,6.823,9.981,9.981,0,0,0,9.595-6.823h14.058Z",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_143",
  "data-name": "Path 143",
  d: "M-8564.689,8027.385a1.247,1.247,0,0,0-1.332,1.144.982.982,0,0,0,0,.131v24.168l-6.4-6.057a1.444,1.444,0,0,0-1.932,0,1.237,1.237,0,0,0,.065,1.785l8.661,8.226a1.307,1.307,0,0,0,1.789.074c.027-.024.052-.048.077-.074l8.661-8.226a1.236,1.236,0,0,0,.066-1.785,1.444,1.444,0,0,0-1.932,0l-6.4,6.057V8028.66a1.232,1.232,0,0,0-1.2-1.275Q-8564.619,8027.382-8564.689,8027.385Z",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 1
})));

var SvgSageIcon3 = function SvgSageIcon3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189.505,
    height: 124.119,
    viewBox: "0 0 189.505 124.119",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSageIcon3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sageIcon3.a40fda79.svg";
export { ForwardRef as ReactComponent };